import actionTypes from '../../constants/actionTypes'

const initialState = {
  detectingMacroObjectId: undefined,
  testFieldResultId: undefined,
  detectedMacros: [],
  fileUploadingFromUrl: false,
  fileUploaded: true,
  apiError: null,
  remainingCredits: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RESET_STATE:
      return initialState;

    case actionTypes.REQUEST_DETECT_MACRO:
      return {
        ...state,
        detectingMacroObjectId: action.detectingMacroObjectId
      }
    case actionTypes.RECEIVE_DETECT_MACRO:
      return {
        ...state,
        detectedMacros: action.detectedMacros
      }
    case actionTypes.SET_TEST_FIELD_RESULT_ID:
      return {
        ...state,
        testFieldResultId: action.testFieldResultId
      }
    case actionTypes.CHANGE_RECTANGLE_FIELD_COORDINATES:
    case actionTypes.CHANGE_RECTANGLE_FIELD_SIZES:
    case actionTypes.CHANGE_RECTANGLE_TABLE_COORDINATES:
    case actionTypes.CHANGE_RECTANGLE_TABLE_SIZES:
    case actionTypes.CHANGE_OBJECT_DATA_TYPE:
      return {
        ...state,
        detectingMacroObjectId: initialState.detectingMacroObjectId,
        testFieldResultId: initialState.testFieldResultId,
        detectedMacros: initialState.detectedMacros
      }
    case actionTypes.REQUEST_UPLOAD_FILE_FROM_URL:
      return {
        ...state,
        fileUploadingFromUrl: true
      }
    case actionTypes.RECEIVE_UPLOAD_FILE_FROM_URL:
      return {
        ...state,
        fileUploadingFromUrl: false
      }

    case actionTypes.MARK_FAIL_TO_FILE_UPLOADED:
      return {
        ...state,
        fileUploaded: false
      }

    case actionTypes.MARK_SUCCESS_TO_FILE_UPLOADED:
      return {
        ...state,
        fileUploaded: true
      }

    case actionTypes.SET_API_ERROR:
      return {
        ...state,
        apiError: action.apiError
      }

    case actionTypes.SET_REMAINING_CREDITS:
      return {
        ...state,
        remainingCredits: action.remainingCredits
      }

    default:
      return state
  }
}
